import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";

export function FooterNewsletter() {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("idle"); // idle | loading | done | error

  const handleSubscribe = async (e) => {
    e.preventDefault();
    setStatus("loading");
    try {
      await api.post("/subscribers/newsletter", { email });
      setStatus("done");
      setEmail("");
    } catch (err) {
      setStatus("error");
    }
  };

  return (
    <div className="lg:col-span-5">
      {status === "done" ? (
        <p data-testid="footer-newsletter-success" className="text-[#4FD1C5] text-sm font-medium">You're on the list. Thank you for joining.</p>
      ) : (
        <form onSubmit={handleSubscribe} className="flex flex-col sm:flex-row gap-3">
          <Input
            type="email" required placeholder="you@example.com" value={email} onChange={(e) => setEmail(e.target.value)}
            data-testid="footer-newsletter-email-input"
            className="bg-white/5 border-white/20 text-white placeholder:text-zinc-500 focus:border-[#4FD1C5] focus:ring-1 focus:ring-[#4FD1C5] rounded-none"
          />
          <Button type="submit" disabled={status === "loading"} data-testid="footer-newsletter-submit-button" className="bg-white text-zinc-950 font-medium rounded-none hover:bg-zinc-200 whitespace-nowrap">
            {status === "loading" ? "Joining..." : "Get Updates"} <ArrowRight className="h-4 w-4 ml-1" />
          </Button>
        </form>
      )}
      <p className="text-xs text-zinc-500 mt-2">
        By signing up, you agree to receive updates from BBAP. Unsubscribe anytime. See our{" "}
        <Link to="/privacy" className="underline hover:text-white">Privacy Policy</Link>.
      </p>
    </div>
  );
}
